import React from 'react';
const STATS = [{
  value: "+100",
  label: 'personas ya confían'
}, {
  value: '4',
  label: 'tomos en PDF'
}, {
  value: '3',
  label: 'bonos incluidos'
}, {
  value: '4,8/5 ⭐',
  label: 'calificación promedio'
}];
export function TrustNumbers() {
  return <section aria-label="Números de confianza" className="bg-night" data-id="element-246" data-mp="2nmipl8lxm7v4">
      <div className="mx-auto grid max-w-page grid-cols-2 gap-px overflow-hidden bg-white/10 px-0 sm:grid-cols-4" data-id="element-247" data-mp="2iopnorrnw00n">
        {STATS.map(stat => <div key={stat.label} className="bg-night px-4 py-6 text-center" data-id="element-248" data-mp="2do301a2jz6nq">
            <p className="font-display text-2xl font-black leading-none text-amber sm:text-[28px]" data-id="element-249" data-mp="29nj2w6hzc31l">
              {stat.value}
            </p>
            <p className="mt-1.5 text-[11.5px] font-semibold leading-tight text-canvas/70" data-id="element-250" data-mp="1zqwkrph1fq39">
              {stat.label}
            </p>
          </div>)}
      </div>
    </section>;
}